import { Routes, Route, Navigate } from 'react-router-dom';

import { List, AddEdit } from '.';
import { ReturnButton } from '_components/buttons';

export { UsersLayout };

function UsersLayout() {
    return (
        <div className="pt-16">
            <div className="container">
                <div className="ml-10 pl-12">
                    <ReturnButton />
                </div>               
                <Routes>
                    <Route index element={<List />} />
                    <Route path="add" element={<AddEdit />} />
                    <Route path="edit/:username" element={<AddEdit />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </div>
        </div>
    );
}
